export default __webpack_public_path__ + "static/media/Palmas.19630a78.jpg";